
export function redirect (target) {
  if (window.event.ctrlKey) {
    window.open (target, '_blank');
  } else {
    this.$router.push (target);
  }
}

export function navigate (to, params, qs) {
  let target = resolve.call (this, to, params, qs);
  redirect (target);
}

export function delegate (e) {
  let path = eventPath (e);

  for (let em of path) {
    if (typeof em.hasAttribute !== 'function') {
      continue;
    }

    if (em.hasAttribute ('data-target')) {
      redirect.call (this, em.getAttribute ('data-target'));
      break;
    }
  }
}

export function resolve (to, params, qs) {
  let target;

  if (typeof to === 'object') {
    target = to;
  } else {
    target = {
      name:   to,
      params: params,
      qs:     qs
    };
  }

  let route = this.$router.resolve (target);
  return route.href;
}

// --

let pos = {
  x: 0,
  y: 0
};

export function setScroll (coords) {
  coords = coords || {};

  if (! ('x' in coords)) {
    coords.x = window.scrollX;
  }

  if (! ('y' in coords)) {
    coords.y = window.scrollY;
  }

  pos.x = coords.x;
  pos.y = coords.y;
}

export function scrollBehavior (to, from, savedPosition) {
  let scrollTo = {};

  if (savedPosition) {
    scrollTo = savedPosition;
  } else {
    scrollTo.x = pos.x;
    scrollTo.y = pos.y;
  }

  setScroll ({
    x: 0,
    y: 0
  });

  return scrollTo;
}